import React, { useCallback, useEffect, useState } from 'react';
import {
  Container,
  Card,
  Box,
  TextField,
  IconButton,
  Button
} from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ClearIcon from '@material-ui/icons/Clear';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WrapperSeamless from '../../layout-components/WrapperSeamless';
import * as Api from '../../service';
import useStore from '../../context';

const Categories = () => {
  const { setRemove, setSuccessMsg, setErrorMsg } = useStore();
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ name: '', slug: '' });
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', slug: '' });

  const loadCategories = useCallback(() => {
    Api.blog.getCategories()
      .then((res) => setCategories(Array.isArray(res) ? res : res?.items || []))
      .catch(() => {});
  }, []);

  useEffect(loadCategories, []);

  const createCategory = async (e) => {
    e.preventDefault();
    if (!form.name) return setErrorMsg('name is required');
    if (!form.slug) return setErrorMsg('slug is required');
    try {
      await Api.blog.createCategory(JSON.stringify(form));
      setForm({ name: '', slug: '' });
      setSuccessMsg('created');
      loadCategories();
    } catch (e) {
      setErrorMsg(e.message);
    }
  };

  const startEdit = (cat) => {
    setEditingId(cat.id || cat._id);
    setEditForm({ name: cat.name || '', slug: cat.slug || '' });
  };

  const updateCategory = async () => {
    try {
      await Api.blog.updateCategory(editingId, JSON.stringify(editForm));
      setEditingId(null);
      setSuccessMsg('updated');
      loadCategories();
    } catch (e) {
      setErrorMsg(e.message);
    }
  };

  return (
    <Container>
      <WrapperSeamless sectionHeading="Blog Categories">
        <Card className="shadow-xxl px-4 py-2">
          <Box component="form" onSubmit={createCategory}>
            <Card className="d-flex p-3 align-items-center">
              <TextField
                variant="outlined"
                className="my-2 mr-2"
                label="Name"
                fullWidth
                value={form.name}
                onChange={(e) =>
                  setForm((st) => ({ ...st, name: e.target.value }))
                }
              />
              <TextField
                variant="outlined"
                className="my-2 mr-2"
                label="Slug"
                fullWidth
                value={form.slug}
                onChange={(e) =>
                  setForm((st) => ({ ...st, slug: e.target.value }))
                }
              />
              <IconButton
                className="ml-2"
                style={{ height: 58 }}
                onClick={createCategory}
              >
                <AddCircleIcon color="primary" fontSize="large" />
              </IconButton>
            </Card>
          </Box>

          {categories?.map((cat) => (
            <Card
              key={cat.id || cat._id}
              className="px-3 my-2 d-flex align-items-center"
            >
              {editingId === (cat.id || cat._id) ? (
                <>
                  <TextField
                    variant="outlined"
                    className="my-2 mr-2"
                    label="Name"
                    fullWidth
                    value={editForm.name}
                    onChange={(e) =>
                      setEditForm((st) => ({ ...st, name: e.target.value }))
                    }
                  />
                  <TextField
                    variant="outlined"
                    className="my-2 mr-2"
                    label="Slug"
                    fullWidth
                    value={editForm.slug}
                    onChange={(e) =>
                      setEditForm((st) => ({ ...st, slug: e.target.value }))
                    }
                  />
                  <Button
                    className="btn-neutral-success mr-2"
                    onClick={updateCategory}
                  >
                    Save
                  </Button>
                  <Button
                    className="btn-neutral-first"
                    onClick={() => setEditingId(null)}
                  >
                    Cancel
                  </Button>
                </>
              ) : (
                <>
                  <span>{cat.name}</span>
                  <span className="ml-3 text-black-50">{cat.slug}</span>
                  <IconButton
                    className="ml-auto"
                    onClick={() => startEdit(cat)}
                  >
                    <FontAwesomeIcon icon={['far', 'edit']} />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      setRemove(() => () =>
                        Api.blog
                          .deleteCategory(cat.id || cat._id)
                          .then(loadCategories)
                      )
                    }
                    className="ml-1"
                  >
                    <ClearIcon color="error" fontSize="medium" />
                  </IconButton>
                </>
              )}
            </Card>
          ))}
        </Card>
      </WrapperSeamless>
    </Container>
  );
};

export default Categories;
